import React from 'react';
import PropTypes from 'prop-types';

import EmptyView from 'components/EmptyView';
import Button from 'components/Button';

const NoSelectedTestSet = ({ toggleTestSetsList }) => {
  const toggleList = () => toggleTestSetsList(true);

  return (
    <EmptyView>
      <p>
        Please select a test set{' '}
        <Button isLink onClick={toggleList}>
          here
        </Button>
      </p>
    </EmptyView>
  );
};

NoSelectedTestSet.propTypes = {
  toggleTestSetsList: PropTypes.func.isRequired,
};

export default NoSelectedTestSet;
